import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CalendarIcon } from '@components/icons/svg-icon.tsx';
import { ScheduleLegendEnum } from '@modules/digital-signage/model/playlist-schedule.model.ts';
import { SCHEDULE_LEGEND_COLORS } from '@modules/digital-signage/utils/schedule-appearance.utils.ts';

const ScheduleLegendHeader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between flex-wrap gap-3">
      <div className="flex items-center gap-2">
        <CalendarIcon fill="var(--dark-1)" className="w-5! h-5!" />
        <Typography variant="subtitle4" className="text-(--dark-1)!">
          {t('digital_signage_schedule_scheduling')}
        </Typography>
      </div>

      <div className="flex items-center gap-3.5">
        {Object.values(ScheduleLegendEnum).map((key) => (
          <span key={key} className="flex items-center gap-1.5">
            <span
              className={`w-3 h-1 rounded-full ${SCHEDULE_LEGEND_COLORS[key]}`}
            />
            <Typography
              variant="caption"
              component="span"
              className="leading-4! text-(--gray-2)!"
            >
              {t(`digital_signage_schedule_legend_${key}`)}
            </Typography>
          </span>
        ))}
      </div>
    </div>
  );
};

export default ScheduleLegendHeader;
